import { PrismButton, PrismBadge, PrismCard } from "@prism-ui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './RoleCard.css'

const RoleCard = ({title, text, roleText, isPending, isSubmitted, windowIsOpen, okToApply, canSwitchTrack, isRole, isApproved, approvedText='Application Submitted', onBegin, onWithdraw, onContinue}) => {
  return (
    <div className={`role-card${isRole ? ' active' : ''}`}>
      <div style={{ padding: '1.25rem' }}>
        <h5>{title}</h5>
        <hr style={{ margin: '0.5rem 0', border: 'none', borderTop: '2px solid var(--color-text)', opacity: 0.4 }} />
        <div>{text}</div>
        {isSubmitted && isRole ? (
          <div style={{ marginTop: '0.5rem' }}>
            {isApproved ? (
              <PrismBadge tone="success">{approvedText}</PrismBadge>
            ) : (
              <PrismBadge tone="info">Awaiting Manager Approval</PrismBadge>
            )}
          </div>
        ) : undefined}
      </div>
      <div style={{ padding: '0.75rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {isPending && isRole ? (<>
          <PrismButton tone="primary-brand" size="lg" onPrismClick={onContinue}>Continue <FontAwesomeIcon icon={faChevronRight} /></PrismButton>
          <button
            type="button"
            onClick={onWithdraw}
            style={{
              backgroundColor: 'var(--color-danger-dk)',
              // Fixed white text on the saturated danger background.
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '0.6rem 1rem',
              fontSize: '0.9rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >Withdraw</button>
        </>
        ) : !isSubmitted && okToApply ? (
          <PrismButton tone={!isPending ? 'primary-brand' : 'secondary'} onPrismClick={onBegin}>
            Begin Application
          </PrismButton>
        ) : !isSubmitted && canSwitchTrack && !isRole && (
          <PrismButton tone="secondary" onPrismClick={onBegin}>
            Switch to this track
          </PrismButton>
        )}
        {isSubmitted && isRole ? (
          <button
            type="button"
            onClick={onWithdraw}
            style={{
              backgroundColor: 'var(--color-danger-dk)',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '0.6rem 1rem',
              fontSize: '0.9rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >Withdraw Application</button>
        ) : undefined}
      </div>
    </div>
  )
}

export default RoleCard